import { IFormField } from "../web-form.objects"
import _ from "lodash";
import { JsonItem } from "../../../entities/pick-list/pick-list.entities";
import { getDisplayDate } from "../../../scripts/date-functions";

export class DateInputOptions {
    constructor() {
        
    }
}

export class DateInputField implements IFormField {
    fieldId: string;
    displayName: string;
    description: string;
    isRequired: boolean;
    propertyName: string;
    defaultVal: any;
    initialVal: any;

    options: DateInputOptions;

    constructor(propertyName: string, fieldId: string, displayName: string, description: string, isRequired: boolean, options: DateInputOptions = new DateInputOptions()) {
        this.fieldId = fieldId;
        this.displayName = displayName;
        this.description = description;
        this.isRequired = isRequired;
        this.propertyName = propertyName;
        this.options = options;

        this.defaultVal = new Date(1, 1, 1);
        this.initialVal = new Date(1, 1, 1);
    }

    generateHtml(): string {
        let requiredClass = "";
        if (this.isRequired) requiredClass = "required";

        let html = `
            <label for="" class="${requiredClass}">${this.displayName}</label>
            ${this.description != "" ? `<p class='form-text'>${this.description}</p>` : ``}
            <input type="date" class="form-control col-12" id="${this.fieldId}">
        `;

        return html;
    }

    initialize() {
        $(`#${this.fieldId}`).on("change keyup", () => {
            $(`#${this.fieldId}`).trigger("form-field-change");
        });
    }

    setOptions(pickLists: JsonItem[]) {
        return;
    }

    prepopulate(items: any[]): void {
        this.initialVal = this.defaultVal;
        // Check if all have valid
        let isValid = items.every(item => _.get(item, this.propertyName));

        if (isValid) {
            // Check if all are the same
            if (items.every((item, i, arr) => _.get(item, this.propertyName) == _.get(arr[0], this.propertyName)) && items.length > 0) {
                this.initialVal = _.get(items[0], this.propertyName);
            }
        }

        this.setInput(this.initialVal);
    }

    updateItem(item: any): any {
        let updatedItem = _.cloneDeep(item);
        _.set(updatedItem, this.propertyName, this.getValue());
        return updatedItem;
    }

    private getInput(): string {
        let input = <string>$(`#${this.fieldId}`).val();
        return input;
    }

    private setInput(data: any): void {
        let dateVal = new Date(data);
        let formattedVal = dateVal.toISOString().split("T")[0];
        // Don't populate if its default year (year 1)
        if (dateVal.getFullYear() > 2000) {
            $(`#${this.fieldId}`).val(formattedVal);
        }
        else {
            $(`#${this.fieldId}`).val("");
        }
    }

    private getParsedInput() {
        let val = this.defaultVal;

        let input = this.getInput();
        if (input) {
            val = input;
        }

        return val;
    }

    getValue(): any {
        let val = this.initialVal;

        let isValid = this.checkValid();
        let isChanged = this.checkChanged();
        if (isValid && isChanged) {
            val = this.getParsedInput();
        }

        return val;
    }

    setValue(formData: any) {
        let formVal = _.get(formData, this.propertyName);
        if (formVal != undefined) {
            this.setInput(formVal);
        }
    }

    checkValid(): boolean {
        let val = this.getInput();

        if (this.isRequired) {
            // empty or spaces
            if (!val) {
                return false;
            }
            return true;
        }
        else {
            return true;
        }
    }

    checkChanged(): boolean {
        let val = this.getParsedInput();
        if (val != this.initialVal) {
            return true;
        }
        return false;
    }

    displayValid(isValid: boolean) {
        if (isValid) {
            $(`#${this.fieldId}`).addClass("is-valid").removeClass("is-invalid");
        }
        else {
            $(`#${this.fieldId}`).removeClass("is-valid").addClass("is-invalid");
        }
    }

    resetValidDisplay() {
        $(`#${this.fieldId}`).removeClass("is-valid").removeClass("is-invalid");
    }

    compareItems(item1: any, item2: any): boolean {
        let x1 = _.get(item1, this.propertyName);
        let x2 = _.get(item2, this.propertyName);

        if (x1) {
            let d = new Date(x1);
            if (d.getFullYear() < 2000) x1 = null;
        }
        if (x2) {
            let d = new Date(x2);
            if (d.getFullYear() < 2000) x2 = null;
        }

        if (!x1 && !x2) {
            return true;
        }
        else if (!x1 || !x2) {
            return false;
        }

        let standardx1 = this.standardizeDateString(x1);
        let standardx2 = this.standardizeDateString(x2);

        let x1Date = new Date(standardx1);
        let x2Date = new Date(standardx2);

        if (x1Date.getTime() == x2Date.getTime()) {
            return true;
        }

        return false;
    }

    generateChangeHtml(newItem: any, prevItem: any): string {
        let isChanged = false;

        if (prevItem == undefined) {
            isChanged = true;
        }
        else {
            isChanged = !this.compareItems(newItem, prevItem);
        }

        if (!isChanged) {
            return "";
        }

        let changeContent = "";

        let newVal = _.get(newItem, this.propertyName);
        if (newVal) {
            let standardNew = this.standardizeDateString(newVal);
            let newDate = new Date(standardNew);
            let newDisplay = `
                    <div class="new-change-block change-block">
                        <div class="col-auto">
                            <i class="fa-solid fa-plus new-change-icon"></i>
                        </div>
                        <div class="col">
                            ${getDisplayDate(newDate)}
                        </div>
                    </div>
                `;
            changeContent = newDisplay;
        }

        if (prevItem != undefined) {
            let prevVal = _.get(prevItem, this.propertyName);
            if (prevVal) {
                let standardPrev = this.standardizeDateString(prevVal);
                let prevDate = new Date(standardPrev);
                let prevDisplay = `
                        <div class="delete-change-block change-block">
                            <div class="col-auto">
                                <i class="fa-solid fa-trash-can delete-change-icon"></i>
                            </div>
                            <div class="col">
                                ${getDisplayDate(prevDate)}
                            </div>
                        </div>
                    `;
                changeContent += prevDisplay;
            }
        }

        let html = `
                <div class="change-content-block">
                    <div class="change-content-label">
                        ${this.displayName}
                    </div>
                    ${changeContent}
                </div>
            `;

        return html;
    }

    private standardizeDateString(dateStr: string): string {
        if (!dateStr) {
            return dateStr;
        }

        if (!dateStr.includes("T")) {
            let standardDateStr = `${dateStr.trim()}T00:00:00`;
            return standardDateStr;
        }

        return dateStr;
    }
}

